











import { Component, Vue } from 'vue-property-decorator'
import NotificationsList from '@/components/notifications-hub-content/notifications-list/notifications-list.vue'
import NotificationsHeader from '@/components/notifications-hub-content/notifications-header/notifications-header.vue'
import InboxRedirectButton from '@/components/notifications-hub-content/inbox-redirect-button/inbox-redirect-button.vue'
import FirstTimeUsageBanner from '@/components/notifications-hub-content/first-time-usage-banner/first-time-usage-banner.vue'

@Component({
  components: {
    NotificationsList,
    NotificationsHeader,
    InboxRedirectButton,
    FirstTimeUsageBanner,
  },
  props: {
    mobile: {
      default: false,
      type: Boolean,
    },
    flyoutOpen: {
      default: false,
      type: Boolean,
    },
    messages: {
      default: 0,
      type: Number,
    },
  },
})
export default class NotificationsHubContent extends Vue {}
